import * as SettingsActionTypes from 'actiontypes/settings';
import SettingsService from 'services/SettingsService';

/** ----------------------------------------------------------------------------
 * RESET PASSWORD
 -----------------------------------------------------------------------------*/

export const resetPasswordRequested = () => ({
  type: SettingsActionTypes.PASSWORD_RESET_REQUESTED,
  isResetting: true,
});

export const resetPasswordSuccess = response => ({
  type: SettingsActionTypes.PASSWORD_RESET_SUCCESS,
  isResetting: false,
  isSuccess: response.isSuccess,
  message: response.message,
});

export const resetPasswordFailure = error => ({
  type: SettingsActionTypes.PASSWORD_RESET_FAILURE,
  isResetting: false,
  error: true,
  status: error.response && error.response.status,
});

export default resetPassword(new SettingsService());

export function resetPassword(service) {
  return reqData => async (dispatch) => {
    dispatch(resetPasswordRequested());

    try {
      const { data } = await service.resetPassword(reqData);
      dispatch(resetPasswordSuccess(data));
      return data;
    } catch (error) {
      dispatch(resetPasswordFailure(error));
      return error;
    }
  };
}